import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {
  deletebillreceipt,
  getbillwisereceipt,
  getcashorbank,
} from "../../services/AccountApiServices";
import { fetchCustomer } from "../../redux/userSetting";
import Billreceiptmodal from "../../components/accounting/Billreceiptmodal";
import { BillReceiptEntry } from "../../core/json/BillReceiptEntry";
import { TransactionScreen } from "../../components/transactions/list";
import { dateOf, dmy, intg, money, num } from "../../components/report/reportFormat";

const BillwiseReceipt = () => {
  const [billpayment, setbillpayment] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [modalMode, setModalMode] = useState("add");
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const { menuItems } = useSelector((state) => state.amc);
  const [permit, setpermit] = useState();
  const MySwal = withReactContent(Swal);
  const { formatedcustomerList } = useSelector((state) => state.usersetting);
  const [bankorcash, setbankorcash] = useState([]);

  useEffect(() => {
    setpermit(
      menuItems?.menuPermissions?.find((e) => e.menu.name == "Bill Receipt")
    );
    handlegetCashorbank();

    dispatch(fetchCustomer(branch));
  }, []);
  useEffect(() => {
    handlebillpayment();
  }, [branch]);
  const handlebillpayment = async () => {
    try {
      const response = await getbillwisereceipt(branch);
      setbillpayment(response.data);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handlegetCashorbank = async () => {
    try {
      const response = await getcashorbank();
      if (Array.isArray(response.data)) {
        const formated = response.data?.map((e) => ({
          label: e.name,
          value: e.guid,
        }));
        setbankorcash(formated);
      } else {
        setbankorcash([]);
      }
    } catch (error) {
      setbankorcash([]);
    }
  };

  const handleEditClick = async (guid) => {
    try {
      const response = billpayment?.find((sales) => sales.guid === guid);
      setUpdateData(response);
      setModalMode("edit");
      setModalOpen(true);
    } catch (error) {
      console.error(
        "Error fetching sales invoice by GUID",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleDeleteClick = (obj) => {
    const objpayment = new BillReceiptEntry();
    objpayment.Branch = branch;
    objpayment.guid = obj.guid;
    objpayment.id = obj.id;
    objpayment.updatedUser = userId?.id;
    objpayment.createdUser = userId?.id;
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deletebillreceipt(objpayment);
          if (response.data === true) {
            MySwal.fire({
              title: "Deleted!",
              text: "The Bill receipt has been deleted.",
              icon: "success",
              confirmButtonColor: "#00ff00",
              confirmButtonText: "OK",
            }).then(() => {
              handlebillpayment();
            });
          } else {
            MySwal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonColor: "#ff0000",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error deleting sales quotation:", error);
          MySwal.fire({
            title: "Error!",
            text: error?.response?.data?.Message || "something went wrong",
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  /* ---------------- list ---------------- */
  // one flat record per bill-wise receipt; the keys match the column definitions
  const rows = useMemo(
    () =>
      (Array.isArray(billpayment) ? billpayment : []).map((r) => {
        const customerId = r.customer?.guid;
        return {
          guid: r.guid,
          raw: r,
          date: dateOf(r.date),
          billNo: r.no != null ? String(r.no) : "",
          customerId,
          customer:
            formatedcustomerList?.find((e) => e.value == customerId)?.label ||
            r.customer?.name ||
            "",
          ledgerID: r.ledgerID,
          ledger: bankorcash?.find((e) => e.value == r.ledgerID)?.label || "",
          narration: r.narration || "",
          discount: num(r.discount),
          items: (r.billReceiptDetails || []).length,
          net: num(r.amount),
          lines: r.billReceiptDetails || [],
        };
      }),
    [billpayment, formatedcustomerList, bankorcash]
  );

  const columns = useMemo(
    () => [
      { k: "date", t: "Date", type: "date", ago: true },
      { k: "billNo", t: "Entry No", type: "doc" },
      { k: "customer", t: "Customer", type: "party" },
      { k: "ledger", t: "Ledger" },
      { k: "narration", t: "Narration" },
      { k: "items", t: "Bills", type: "int", off: true },
      { k: "discount", t: "Discount", type: "money" },
      { k: "net", t: "Amount", type: "money" },
    ],
    []
  );

  const tabs = useMemo(() => [{ id: "all", label: "Billwise Receipt" }], []);

  const filters = useMemo(
    () => [
      {
        key: "ledger",
        label: "Ledger",
        items: (bankorcash || []).map((l) => ({ v: l.value, t: l.label || "—" })),
        match: (r, v) => v.includes(r.ledgerID),
      },
      {
        key: "customer",
        label: "Customer",
        items: (formatedcustomerList || []).map((c) => ({
          v: c.value,
          t: c.label || "—",
        })),
        match: (r, v) => v.includes(r.customerId),
      },
    ],
    [bankorcash, formatedcustomerList]
  );

  const searchMatch = (r, q) => {
    const hit = (s) => String(s || "").toLowerCase().includes(q);
    return (
      hit(r.billNo) ||
      hit(r.customer) ||
      hit(r.ledger) ||
      hit(r.narration) ||
      hit(r.date) ||
      String(r.net).includes(q) ||
      String(r.discount).includes(q) ||
      r.lines.some((l) => hit(l?.entryNumber) || hit(l?.invoiceNO))
    );
  };

  const drawerContent = (r) => ({
    title: r.customer || "Bill wise receipt",
    subtitle: [`Receipt ${r.billNo}`, dmy(r.date)].filter(Boolean).join("  ·  "),
    avatarKey: r.customer,
    meta: [
      { k: "Customer", v: r.customer },
      { k: "Ledger", v: r.ledger },
      { k: "Narration", v: r.narration },
      { k: "Discount", v: money(r.discount) },
      { k: "Bills", v: intg(r.items) },
    ],
    lines: {
      title: "Bills settled",
      columns: [
        { t: "Bill" },
        { t: "Date" },
        { t: "Bill amount", align: "right" },
        { t: "Received", align: "right" },
        { t: "Discount", align: "right" },
      ],
      rows: r.lines.map((l) => [
        <div key="nm" className="axr-nm">
          {[l?.transType, l?.entryNumber].filter(Boolean).join(" ") || "—"}
          {l?.invoiceNO ? ` · Inv ${l.invoiceNO}` : ""}
        </div>,
        dmy(l?.entryDate),
        money(l?.netTotal),
        money(l?.amount),
        money(l?.discount),
      ]),
    },
    net: { l: "Amount", v: money(r.net) },
  });

  return (
    <TransactionScreen
      title="Bills Wise Receipt"
      subtitle="Manage bill wise receipt here"
      unit="receipts"
      rows={rows}
      columns={columns}
      tabs={tabs}
      filters={filters}
      searchMatch={searchMatch}
      searchPlaceholder="Entry no, customer, ledger, narration, bill no…"
      sortOptions={[
        { v: "date:-1", t: "Newest first" },
        { v: "date:1", t: "Oldest first" },
        { v: "net:-1", t: "Largest amount" },
        { v: "net:1", t: "Smallest amount" },
      ]}
      exportName="Bill wise receipt"
      onRefresh={handlebillpayment}
      // the old page's New button was not permission-gated ({permit?.add && ...} is commented out)
      canAdd
      newLabel="New receipt"
      onNew={() => {
        setModalMode("add"); // Set the modal mode to 'add'
        setModalOpen(true); // Open the modal
      }}
      canEdit={permit?.edit}
      onEdit={(r) => handleEditClick(r.guid)}
      editLabel="Edit receipt"
      canDelete={permit?.deletion}
      onDelete={(r) => handleDeleteClick(r.raw)}
      drawerContent={drawerContent}
      keysDisabled={modalOpen}
    >
      {/* Reason Modal */}
      {modalOpen && (
        <Billreceiptmodal
          mode={modalMode}
          bankorcash={bankorcash}
          data={modalMode === "edit" ? updateData : {}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {
            handlebillpayment();
          }}
        />
      )}
    </TransactionScreen>
  );
};

export default BillwiseReceipt;
